// https://ispaj.co.ao/back/storage/images/image_1744720970.jpeg

import axios from "axios";

// const baseIp = "ispaj.co.ao/back";
// export const baseURL = `https://${baseIp}`;
// export const baseIp = "160.242.26.156:9000"
export const baseIp = `apisiteispaj.level-school.ao`
export const baseURL = `https://${baseIp}`

// const api = axios.create({
//   baseURL: `${baseUrl}api/v1/`,
//   // transitional: {
//   //   silentJSONParsing: false,
//   // },
//   // responseType: "json",
// });

// export default api;
